<template>
  <div>
    <div class="section" v-if="!tarotData.loading">
      <div class="container section__content">
        <h2 class="std__subtile">{{ $t("tarot_cards") }}</h2>
        <p class="std__subtile md purple">{{ $t("major") }}</p>
        <tarot-slider
          :major="tarotData.majors"
          :getTarot="getTarot"
        ></tarot-slider>
      </div>
    </div>
    <div class="section" v-if="!tarotData.loading">
      <div class="container section__content">
        <p class="std__subtile md purple">{{ $t("minor") }}</p>
        <div class="row">
          <div class="col-md-3 col-6">
            <h2 class="tarotLabel">{{ $t("wands") }}</h2>
            <ul class="tarotUl">
              <li
                v-for="wand in tarotData.wands"
                :key="wand.key"
                v-on:click="getTarot(wand.name_short)"
              >
                <a
                  class="tarotLink"
                  data-toggle="modal"
                  data-target="#astroModal"
                  :key="wand.key"
                  >{{ wand.name }}</a
                >
              </li>
            </ul>
          </div>
          <div class="col-md-3 col-6">
            <h2 class="tarotLabel">{{ $t("cups") }}</h2>
            <ul class="tarotUl">
              <li
                v-for="cup in tarotData.cups"
                :key="cup.key"
                v-on:click="getTarot(cup.name_short)"
              >
                <a
                  class="tarotLink"
                  data-toggle="modal"
                  data-target="#astroModal"
                  :key="cup.key"
                  >{{ cup.name }}</a
                >
              </li>
            </ul>
          </div>
          <div class="col-md-3 col-6">
            <h2 class="tarotLabel">{{ $t("swords") }}</h2>
            <ul class="tarotUl">
              <li
                v-for="sword in tarotData.swords"
                :key="sword.key"
                v-on:click="getTarot(sword.name_short)"
              >
                <a
                  class="tarotLink"
                  data-toggle="modal"
                  data-target="#astroModal"
                  :key="sword.key"
                  >{{ sword.name }}</a
                >
              </li>
            </ul>
          </div>
          <div class="col-md-3 col-6">
            <h2 class="tarotLabel">{{ $t("pentacles") }}</h2>
            <ul class="tarotUl">
              <li
                v-for="pentacle in tarotData.pentacles"
                :key="pentacle.key"
                v-on:click="getTarot(pentacle.name_short)"
              >
                <a
                  class="tarotLink"
                  data-toggle="modal"
                  data-target="#astroModal"
                  :key="pentacle.key"
                  >{{ pentacle.name }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="astroModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="astroModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl modalCustom">
        <div class="modal-content" v-for="tarot in tarots" :key="tarot.key">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ tarot.name }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="left col-md-3">
                <div class="thumbnail">
                  <img :src="tarot.image" alt />
                </div>
              </div>
              <div class="right col-md-8">
                <div class="stdGroup">
                  <h2 class="std__subtile">{{ $t("description") }}</h2>
                  <p v-if="language === 'english'">{{ tarot.desc }}</p>
                  <p v-if="language !== 'english'">{{ descTranslate }}</p>
                </div>

                <div class="stdGroup">
                  <h2 class="std__subtile md">{{ $t("meaning") }}</h2>
                  <p v-if="language === 'english'"> {{ tarot.meaning_up }} {{ tarot.meaning_rev }}</p>
                  <p v-if="language !== 'english'">{{ meaningTranslate }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ $t("close") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import TarotSlider from "./TarotSlider.vue";
import { mapGetters, mapActions } from "vuex";
import country_list from "./../../locales/country_list.json";

var TJO = require("translate-json-object")();
const proxyurl = "https://cors-anywhere.herokuapp.com/";
const URL = "https://rws-cards-api.herokuapp.com/api/v1/cards";

Vue.component("tarot-silder", TarotSlider);
export default {
  data() {
    return {
      tarots: {},
      descTranslate: "",
      meaningTranslate: "",
      meaning: ""
    };
  },
  components: {
    TarotSlider
  },
  mounted() {},
  props: ["tarotData"],
  computed: mapGetters(["language", "translateCode", "countryCode"]),
  methods: {
    getTarot(tarot) {
      //description and meaning to reset if user click another card
      this.descTranslate = "";
      this.meaningTranslate = "";

      //to get information for each card
      let tar = [];
      let tarotData = this.tarotData.data; //get data from props

      for (let [key, value] of Object.entries(tarotData)) {
        if (value.name_short == tarot) {
          //only for Fortitude card
          if (value.name == "Strength(Fortitude)") {
            value.name = "Fortitude";
          }
          value.image = require(`../../assets/mobiscope/imgs/tarot_image/${value.name}.jpg`);
          if (value.name == "Fortitude") {
            value.name = "Strength(Fortitude)";
          }
          tar.push(value);
        }
      }
      
      this.tarots = tar;

      this.meaning = `${this.tarots[0].meaning_up} ${this.tarots[0].meaning_rev}`;

      TJO.init({
        googleApiKey: 'AIzaSyCq1acQaQt46Yx2VK1BrlYm19SN7hqbf04',
        // yandexApiKey: "trnsl.1.1.20191111T072241Z.a4ad72c3f47a325f.7a1d4907e47128f839d39d2241ed3fcc0414ada7"
      });

      var desc = {
        desc: this.tarots[0].desc,
        meaning: " "+this.meaning
      };
      
      if(this.translateCode != ""){
        TJO.translate(desc, this.translateCode).then((data) => {
          this.descTranslate = data.desc;
          this.meaningTranslate = data.meaning;
        })
        .catch(function(err) {
          console.log("error ", err);
        });
      }
    }
  }
};
</script>

<style lang="scss">
.tarotLabel {
  font-size: 1.2rem;
  text-transform: uppercase;
}
.tarotUl {
  li {
    margin: 8px 0px;
  }
}

a {
  color: white;
  font-weight: 600;
  cursor: pointer;
}
.major_wrap {
  background: #dc00ac;
  height: 37px;
  margin: 5px;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
  color: black;
}
.tarotUl {
  margin-bottom: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mobiscope/Tarot.vue